import Blue from '~/core';
import Swiper, { Navigation, Autoplay } from 'swiper';

Swiper.use([Navigation, Autoplay]);

new Blue({
  name: 'FeatureListCarousel',
  selector: '.feature-list',
  setup(featureList) {
    const detailed = featureList.classList.contains('feature-list--detailed');
    let container = featureList.querySelector('.feature-list__container');
    let wrapper = featureList.querySelector('.feature-list__wrapper');
    let slides = [...featureList.querySelectorAll('.feature-list__slide')];
    let prev = featureList.querySelector('.feature-list__nav--prev');
    let next = featureList.querySelector('.feature-list__nav--next');

    const bindClasses = (addRemove = 'add') => {
      container.classList[addRemove]('swiper-container');
      wrapper.classList[addRemove]('swiper-wrapper');
      slides.forEach(i => {
        i.classList[addRemove]('swiper-slide');
      });
    };

    const opts = {
      speed: 500,
      loop: true,
      allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      on: {
        beforeInit: function () {},
      },
      ...(!detailed && {
        autoplay: {
          delay: 4500,
        },
      }),
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        485: {
          slidesPerView: 2,
        },
        650: {
          slidesPerView: 3,
        },
        850: {
          slidesPerView: 4,
        },
        991: {
          slidesPerView: 5,
        },
      },
    };

    let slider;

    if (!detailed) {
      bindClasses();
      setTimeout(() => {
        slider = new Swiper(container, opts);
      }, 10);
    } else {
      if (this.$screen.md.matches) {
        bindClasses();
        setTimeout(() => {
          slider = new Swiper(container, opts);
        }, 10);
      }
      this.$screen.md.addEventListener('change', e => {
        if (e.matches) {
          bindClasses();
          setTimeout(() => {
            slider = new Swiper(container, opts);
          }, 10);
        } else {
          slider.destroy();
          setTimeout(() => {
            bindClasses('remove');
          }, 10);
        }
      });
    }
  },
});
